import { render, staticRenderFns } from "./intelligent_underwriting.vue?vue&type=template&id=381518b1&scoped=true&"
import script from "./intelligent_underwriting.vue?vue&type=script&lang=js&"
export * from "./intelligent_underwriting.vue?vue&type=script&lang=js&"
import style0 from "./intelligent_underwriting.vue?vue&type=style&index=0&id=381518b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381518b1",
  null
  
)

export default component.exports